import { CampaignDetailPage } from '@/features/campaign/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/campaigns/$campaignId/')({
  component: CampaignDetailPage,
});
